module.exports = __webpack_public_path__ + "./images/6b3993d96eb7aaf2d6d67dabe41c8adf.webp";